import { render, staticRenderFns } from "./CustomerCorporateExport.vue?vue&type=template&id=71e95538&scoped=true"
import script from "./CustomerCorporateExport.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e95538",
  null
  
)

export default component.exports